import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import AuthActions from '../../Redux/AuthRedux';
import ToasterActions from '../../Redux/ToasterRedux';
import LayoutStyles from '../../Components/Layout/Styles/LayoutStyles';
import Routes from '../../Routing/Routes';

const useStyles = makeStyles(theme => ({
  layout: { ...LayoutStyles.centered800Layout, placeContent: 'center' },
  paper: {
    padding: theme.spacing(8),
    textAlign: 'center',
  },
  searchIcon: {
    marginTop: theme.spacing(2),
    width: '2em!important',
    height: '2em!important',
  },
}));

const SignUpConfirmation = () => {
  const classes = useStyles();
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { token, email } = match.params;

  const currentUser = useSelector(state => state.auth.currentUser);
  const isFetching = useSelector(state => state.auth.isFetching);

  const userReady =
    currentUser &&
    currentUser.email === email &&
    currentUser.validation_status === 'email_validated';

  React.useEffect(() => {
    if (userReady)
      dispatch(
        ToasterActions.showToaster(
          { id: 'WELLO.SIGN_UP_CONFIRMATION.ALREADY_SUCCESS' },
          'success',
          5000,
        ),
      );
    if (!userReady && token && email) {
      dispatch(AuthActions.signUpConfirmationRequest(token, email));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isFetching && userReady)
    return <Redirect to={Routes.getSignInRedirectionLink(currentUser, false)} />;

  return (
    <Grid container className={classes.layout}>
      <Grid className={classes.paper}>
        {(!token || !email) && <Typography variant="body1">!!! ERROR !!!</Typography>}
        {token && email && (
          <>
            <Typography component="h4" variant="h4">
              {t('WELLO.SIGN_UP_CONFIRMATION.WAITING', { email })}
            </Typography>
            <CircularProgress className={classes.searchIcon} />
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default SignUpConfirmation;
